import { render } from "./EditProfile.vue?vue&type=template&id=bb9b4ac6&scoped=true"
import script from "./EditProfile.vue?vue&type=script&lang=js"
export * from "./EditProfile.vue?vue&type=script&lang=js"

import "./EditProfile.vue?vue&type=style&index=0&id=bb9b4ac6&lang=scss&scoped=true"
import "./EditProfile.vue?vue&type=style&index=1&id=bb9b4ac6&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb9b4ac6"]])

export default __exports__